import { render, staticRenderFns } from "./RenderFormBuilderComponent.vue?vue&type=template&id=15640312&scoped=true&"
import script from "./RenderFormBuilderComponent.vue?vue&type=script&lang=js&"
export * from "./RenderFormBuilderComponent.vue?vue&type=script&lang=js&"
import style0 from "./RenderFormBuilderComponent.vue?vue&type=style&index=0&id=15640312&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "15640312",
  null
  
)

export default component.exports